/**
 * Alshallal Pastry Company - Nationalities List
 * Comprehensive list of all nationalities with English and Arabic labels
 */

export const NATIONALITIES = [
  // Gulf Countries (GCC)
  { value: 'saudi', label: { en: 'Saudi Arabian', ar: 'سعودي' }, code: 'SA' },
  { value: 'emirati', label: { en: 'Emirati', ar: 'إماراتي' }, code: 'AE' },
  { value: 'kuwaiti', label: { en: 'Kuwaiti', ar: 'كويتي' }, code: 'KW' },
  { value: 'qatari', label: { en: 'Qatari', ar: 'قطري' }, code: 'QA' },
  { value: 'bahraini', label: { en: 'Bahraini', ar: 'بحريني' }, code: 'BH' },
  { value: 'omani', label: { en: 'Omani', ar: 'عماني' }, code: 'OM' },
  
  // Middle East
  { value: 'yemeni', label: { en: 'Yemeni', ar: 'يمني' }, code: 'YE' },
  { value: 'iraqi', label: { en: 'Iraqi', ar: 'عراقي' }, code: 'IQ' },
  { value: 'jordanian', label: { en: 'Jordanian', ar: 'أردني' }, code: 'JO' },
  { value: 'lebanese', label: { en: 'Lebanese', ar: 'لبناني' }, code: 'LB' },
  { value: 'syrian', label: { en: 'Syrian', ar: 'سوري' }, code: 'SY' },
  { value: 'palestinian', label: { en: 'Palestinian', ar: 'فلسطيني' }, code: 'PS' },
  { value: 'iranian', label: { en: 'Iranian', ar: 'إيراني' }, code: 'IR' },
  { value: 'turkish', label: { en: 'Turkish', ar: 'تركي' }, code: 'TR' },
  
  // North Africa
  { value: 'egyptian', label: { en: 'Egyptian', ar: 'مصري' }, code: 'EG' },
  { value: 'sudanese', label: { en: 'Sudanese', ar: 'سوداني' }, code: 'SD' },
  { value: 'libyan', label: { en: 'Libyan', ar: 'ليبي' }, code: 'LY' },
  { value: 'tunisian', label: { en: 'Tunisian', ar: 'تونسي' }, code: 'TN' },
  { value: 'algerian', label: { en: 'Algerian', ar: 'جزائري' }, code: 'DZ' },
  { value: 'moroccan', label: { en: 'Moroccan', ar: 'مغربي' }, code: 'MA' },
  
  // South Asia
  { value: 'indian', label: { en: 'Indian', ar: 'هندي' }, code: 'IN' },
  { value: 'pakistani', label: { en: 'Pakistani', ar: 'باكستاني' }, code: 'PK' },
  { value: 'bangladeshi', label: { en: 'Bangladeshi', ar: 'بنغلاديشي' }, code: 'BD' },
  { value: 'sri_lankan', label: { en: 'Sri Lankan', ar: 'سريلانكي' }, code: 'LK' },
  { value: 'nepali', label: { en: 'Nepali', ar: 'نيبالي' }, code: 'NP' },
  { value: 'afghan', label: { en: 'Afghan', ar: 'أفغاني' }, code: 'AF' },
  
  // Southeast Asia
  { value: 'filipino', label: { en: 'Filipino', ar: 'فلبيني' }, code: 'PH' },
  { value: 'indonesian', label: { en: 'Indonesian', ar: 'إندونيسي' }, code: 'ID' },
  { value: 'malaysian', label: { en: 'Malaysian', ar: 'ماليزي' }, code: 'MY' },
  { value: 'thai', label: { en: 'Thai', ar: 'تايلاندي' }, code: 'TH' },
  { value: 'vietnamese', label: { en: 'Vietnamese', ar: 'فيتنامي' }, code: 'VN' },
  { value: 'singaporean', label: { en: 'Singaporean', ar: 'سنغافوري' }, code: 'SG' },
  
  // East Asia
  { value: 'chinese', label: { en: 'Chinese', ar: 'صيني' }, code: 'CN' },
  { value: 'japanese', label: { en: 'Japanese', ar: 'ياباني' }, code: 'JP' },
  { value: 'korean', label: { en: 'South Korean', ar: 'كوري جنوبي' }, code: 'KR' },
  
  // Europe
  { value: 'british', label: { en: 'British', ar: 'بريطاني' }, code: 'GB' },
  { value: 'french', label: { en: 'French', ar: 'فرنسي' }, code: 'FR' },
  { value: 'german', label: { en: 'German', ar: 'ألماني' }, code: 'DE' },
  { value: 'italian', label: { en: 'Italian', ar: 'إيطالي' }, code: 'IT' },
  { value: 'spanish', label: { en: 'Spanish', ar: 'إسباني' }, code: 'ES' },
  { value: 'dutch', label: { en: 'Dutch', ar: 'هولندي' }, code: 'NL' },
  { value: 'belgian', label: { en: 'Belgian', ar: 'بلجيكي' }, code: 'BE' },
  { value: 'swiss', label: { en: 'Swiss', ar: 'سويسري' }, code: 'CH' },
  { value: 'austrian', label: { en: 'Austrian', ar: 'نمساوي' }, code: 'AT' },
  { value: 'polish', label: { en: 'Polish', ar: 'بولندي' }, code: 'PL' },
  { value: 'romanian', label: { en: 'Romanian', ar: 'روماني' }, code: 'RO' },
  { value: 'greek', label: { en: 'Greek', ar: 'يوناني' }, code: 'GR' },
  { value: 'portuguese', label: { en: 'Portuguese', ar: 'برتغالي' }, code: 'PT' },
  { value: 'swedish', label: { en: 'Swedish', ar: 'سويدي' }, code: 'SE' },
  { value: 'norwegian', label: { en: 'Norwegian', ar: 'نرويجي' }, code: 'NO' },
  { value: 'danish', label: { en: 'Danish', ar: 'دنماركي' }, code: 'DK' },
  { value: 'finnish', label: { en: 'Finnish', ar: 'فنلندي' }, code: 'FI' },
  { value: 'russian', label: { en: 'Russian', ar: 'روسي' }, code: 'RU' },
  { value: 'ukrainian', label: { en: 'Ukrainian', ar: 'أوكراني' }, code: 'UA' },
  
  // Americas
  { value: 'american', label: { en: 'American', ar: 'أمريكي' }, code: 'US' },
  { value: 'canadian', label: { en: 'Canadian', ar: 'كندي' }, code: 'CA' },
  { value: 'mexican', label: { en: 'Mexican', ar: 'مكسيكي' }, code: 'MX' },
  { value: 'brazilian', label: { en: 'Brazilian', ar: 'برازيلي' }, code: 'BR' },
  { value: 'argentinian', label: { en: 'Argentinian', ar: 'أرجنتيني' }, code: 'AR' },
  { value: 'colombian', label: { en: 'Colombian', ar: 'كولومبي' }, code: 'CO' },
  
  // Africa (Sub-Saharan)
  { value: 'nigerian', label: { en: 'Nigerian', ar: 'نيجيري' }, code: 'NG' },
  { value: 'ethiopian', label: { en: 'Ethiopian', ar: 'إثيوبي' }, code: 'ET' },
  { value: 'kenyan', label: { en: 'Kenyan', ar: 'كيني' }, code: 'KE' },
  { value: 'south_african', label: { en: 'South African', ar: 'جنوب أفريقي' }, code: 'ZA' },
  { value: 'ghanaian', label: { en: 'Ghanaian', ar: 'غاني' }, code: 'GH' },
  { value: 'cameroonian', label: { en: 'Cameroonian', ar: 'كاميروني' }, code: 'CM' },
  { value: 'senegalese', label: { en: 'Senegalese', ar: 'سنغالي' }, code: 'SN' },
  
  // Oceania
  { value: 'australian', label: { en: 'Australian', ar: 'أسترالي' }, code: 'AU' },
  { value: 'new_zealander', label: { en: 'New Zealander', ar: 'نيوزيلندي' }, code: 'NZ' },
  
  // Other
  { value: 'other', label: { en: 'Other', ar: 'أخرى' }, code: 'XX' },
];

// Helper function to get nationality label by value
export const getNationalityLabel = (value, isRTL = false) => {
  const nationality = NATIONALITIES.find(n => n.value === value);
  if (!nationality) return value;
  return isRTL ? nationality.label.ar : nationality.label.en;
};

// Helper function to check if Saudi (for document requirements)
export const isSaudi = (value) => value === 'saudi';

// Export for backward compatibility
export default NATIONALITIES;
